// src/components/common/editor/EditorFileChooser.js
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// i18n
import { useI18n } from '../../../i18n/I18nContext';

export default function EditorFileChooser(props) {
  const fileInput = React.useRef();
  const { label, sx, onChange, ...other } = props;

  const { t } = useI18n();

  return (
    <Box
      sx={{
        m: 1.5,
        ...sx
      }}
      {...other}
    >
      <Button
        variant="outlined"
        onClick={() => fileInput.current.click()}
      >
        {/* Se vier label de fora, usa ela. Senão, usa nossa tradução padrão */}
        {label || t('editorFileChooserSelect')}
      </Button>

      <input
        ref={fileInput}
        type="file"
        style={{ display: 'none' }}
        onChange={onChange}
      />
    </Box>
  );
}